import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ClientUpdateDocumentModel } from 'src/app/models/archive/client-update-document.model';
import { ClientModel } from 'src/app/models/archive/client.model';
import { UpdateStateClientResponseModel } from 'src/app/models/archive/update-state-client-response.model';
import { ValidateClientResponseModel } from 'src/app/models/archive/ValidateClientResponse.Model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { ClientImportModel } from 'src/app/models/imports/client-import.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { environment } from 'src/environments/environment';
import { ConstructionSiteModel } from './../../models/archive/construction-site.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private _httpClient: HttpClient) { }

  createClient(clientContractModel: ClientModel): Observable<ClientModel> {
    return this._httpClient.post<ClientModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.CreateClient}`,
      clientContractModel);
  }

  createConstructionSite(clientContractModel: ClientModel): Observable<ConstructionSiteModel> {
    return this._httpClient.post<ConstructionSiteModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.CreateConstructionSite}`,
      clientContractModel);
  }

  deleteClient(clientId: number): Observable<ClientModel> {
    return this._httpClient.delete<ClientModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.DeleteClient}/${clientId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.client.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllclientStatesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetAllClientStatesForSelectAsync}`,);
  }

  getAllCurrenciesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetAllCurrenciesForSelectAsync}`,);
  }

  getAllTypeDocumentsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetAllTypeDocumentsForSelectAsync}`,);
  }

  getAllTypePersonsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetAllTypePersonsForSelectAsync}`,);
  }

  getAllClientsForSelectAsync(): Observable<Array<CustomListDropdown>> {
    return this._httpClient.get<Array<CustomListDropdown>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetAllClientsForSelectAsync}`,);
  }

  getAllClientsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetAllClientsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getCitiesAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetCitiesAsync}`,
      filters, { params: params }
    );
  }

  getCityDepartment(cityId: number): Observable<string> {
    return this._httpClient.get<string>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetCityDepartment}/${cityId}`);
  }

  getClientByDocument(document: string, document2: string): Observable<ClientModel> {
    const itemFilterResponse = new ItemFilterModel("documents", null, null, "");
    itemFilterResponse.wildcard = document;
    itemFilterResponse.wildcard2 = document2;
    return this._httpClient.post<ClientModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetClientByDocument}`,
      itemFilterResponse);
  }

  getClientById(clientId: number): Observable<ClientModel> {
    return this._httpClient.get<ClientModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetClientById}/${clientId}`);
  }

  getColumnsForCitiesAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetColumnsForCitiesAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetColumnsForGeneralConsultationAsync}`);
  }

  getDigitVerification(document: string): Observable<number> {
    const itemFilterResponse = new ItemFilterModel("document", null, null, "");
    itemFilterResponse.wildcard = document;
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.GetDigitVerification}`, itemFilterResponse);
  }

  importClients(clientImports: Array<ClientImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.ImportClients}`,
      clientImports);
  }

  updateClient(clientContractModel: ClientModel): Observable<ClientModel> {
    return this._httpClient.put<ClientModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.UpdateClient}`,
      clientContractModel);
  }

  updateClientAndConstructionSite(updateStateClientResponseModel: UpdateStateClientResponseModel): Observable<string> {
    return this._httpClient.post<string>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.UpdateClientAndConstructionSite}`,
      updateStateClientResponseModel);
  }

  updateClientDocument(providerContractModel: ClientUpdateDocumentModel): Observable<ClientModel> {
    return this._httpClient.put<ClientModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.UpdateClientDocument}`,
      providerContractModel);
  }

  validateStates(clientId: number, clientStateId: number): Observable<ValidateClientResponseModel> {
    return this._httpClient.get<ValidateClientResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.client.ValidateStates}/${clientId}/${clientStateId}`);
  }
}
